import {
  ForgotPasswordData,
  LoginCredentials,
  RegisterData,
  ResetPasswordData,
} from "../types/auth";
import { axiosInstance } from "./axiosInstance";

export const authApiCalls = {
  register: async (values: RegisterData) => {
    const {
      name,
      lastname,
      email,
      document_number,
      password,
      password_confirmation,
      telephone,
    } = values;

    const response = await axiosInstance.post(`/registerUser`, {
      name,
      lastname,
      email,
      document_number,
      password,
      password_confirmation,
      telephone,
    });
    return response;
  },
  login: async (values: LoginCredentials) => {
    const { email, password } = values;

    const response = await axiosInstance.post(`/auth/login`, {
      email,
      password,
    });
    return response;
  },
  forgotPassword: async (values: ForgotPasswordData) => {
    const { email } = values;

    const response = await axiosInstance.post(`/forgot-password`, {
      email,
    });
    return response;
  },
  resetPassword: async (values: ResetPasswordData) => {
    const { email, token, password, password_confirmation } = values;

    const response = await axiosInstance.post(`/password/reset`, {
      email,
      password,
      token,
      password_confirmation,
    });

    return response;
  },
  registerSuccess: async (token: string) => {
    const response = await axiosInstance.get(`/email/verifyAccount/${token}`);
    return response;
  },
};
